import { Link } from "react-router";

import { ROUTES } from "@/shared/config";
import { formatDateTime } from "@/shared/lib";
import { Icon, type IconName } from "@/shared/ui";

import { asActivityType, type ActivityItem, type ActivityType } from "../model/types";

/**
 * Figma: `ActivityRow` (18:46), варианты Decision / Trade / Profit / Alert /
 * System. Шесть типов бэкенда разложены по пяти вариантам макета.
 *
 * `title` и `body` приходят с бэкенда готовыми русскими строками и в ru.json
 * не заводятся: сервер отдаёт текст, клиент его показывает.
 */
const ICONS: Record<ActivityType, IconName> = {
  // Решение робота — искра: это единственное событие, которое «придумано»
  // моделью, а не посчитано.
  ai_decision: "sparkle",
  daily_result: "chartLineUp",
  robot_purchased: "robot",
  deposit: "arrowCircleDown",
  withdrawal: "arrowCircleUp",
  referral: "shareNetwork",
};

export function ActivityRow({ item }: { item: ActivityItem }) {
  const type = asActivityType(item.type);

  return (
    <Link
      to={ROUTES.activityItem(item.id)}
      className={[
        "press-row flex w-full items-start gap-3 rounded-2xl border p-4",
        "transition-colors duration-[var(--motion-fast)] ease-standard",
        item.is_read
          ? "border-border-subtle bg-background-elevated"
          : "border-action-primary bg-surface-selected",
      ].join(" ")}
    >
      <span className="flex size-9 shrink-0 items-center justify-center rounded-full bg-surface-secondary">
        <Icon name={type ? ICONS[type] : "sparkle"} size={17} className="text-text-primary" />
      </span>

      <span className="flex min-w-0 flex-1 flex-col gap-0.5">
        <span className="text-label font-semibold text-text-primary">{item.title}</span>
        <span className="line-clamp-2 text-caption font-normal text-text-secondary">{item.body}</span>
        <span className="text-caption font-normal text-text-tertiary">
          {formatDateTime(item.created_at)}
        </span>
      </span>
    </Link>
  );
}
